import React from 'react';
import { Assign } from 'utility-types';
import { RadioGroup as MUIRadioGroup } from '@material-ui/core';

type RadioGroupProps = Assign<
  React.HTMLAttributes<HTMLDivElement>,
  {
    value: string | null;
    row?: boolean;
    // XXX the semantics of this prop don't match the conventional definition of onChange
    onChange: (value: string, e?: React.ChangeEvent<HTMLInputElement>) => void;
  }
>;

const UNSELECTED = '';

export const RadioGroup = React.forwardRef<HTMLDivElement, RadioGroupProps>(
  ({ value, onChange, children, row }, ref) => {
    return (
      <MUIRadioGroup
        ref={ref}
        row={row}
        // Radio Group is not happy with `null` value
        // https://github.com/mui-org/material-ui/issues/14696
        value={value ?? UNSELECTED}
        onChange={e => onChange(e.currentTarget.value, e)}
      >
        {children}
      </MUIRadioGroup>
    );
  },
);

RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
